//#region Dependencias
import React, { Component } from "react";
import StandardDataTable from "./StandardDataTable";
import { DISPATCH_ID } from "../libs/utils/Const";
import { connect } from "react-redux";
import "../css/dataTables.css";
import $ from "jquery";
//#endregion

//#region Variables globales
const headersDefault = [
    { title: "Código", value: true, filter: true, field: "Code", format: null, classes: "text-left" },
    { title: "Nombre", value: true, filter: true, field: "Name", format: null, classes: "text-left" },
];
//#endregion

class StandardSelectModal extends Component {
    //#region Acciones del componente
    constructor (props) {
        super(props);
        this.state = {
            searchBar: "",
            data: [],

            //#region Selección multiple
            selectedAll: false,
            selectionList: []
            //#endregion
        };
        this.dataTable = React.createRef();
    }

    componentDidMount() {
        const {
            id,
            closeAction,
            searchBar = "",
            selectedItems,
        } = this.props;

        if (!!closeAction) { this.closeAction( id || "standardSelectModal", closeAction ); }

        this.searchInTable(searchBar);

        if (Array.isArray(selectedItems)) {
            this.setState({ selectionList: selectedItems });
        }
    }

    closeModal = async (id) => {
        $(`#${id}`).modal("hide");
    };

    closeAction = (id, cleanData) => {
        $(`#${id}`).on("hidden.bs.modal", () => { cleanData(); });
    };
    
    selectMultipleAction = async () => {
        const { id, selectAction, warningQtySelection, limitQtySelection, notificationReducer: { showAlert }, validNoSelection } = this.props;
        const { selectionList } = this.state;
        if (selectionList.length === 0 && !validNoSelection) { return showAlert({type: "warning", message: "Selecciona elementos de la lista para agregar"}); }
        if (selectionList.length > (limitQtySelection || 1000)) { return showAlert({type: "info", message: `La consulta es muy pesada para procesarla, por favor seleccione menos de ${limitQtySelection || 1000} elementos`}); }
        if (selectionList.length > (warningQtySelection || 100)) { showAlert({type: "info", message: "Por la cantidad de elementos seleccionados, este proceso puede tardar unos minutos"}); }
        await selectAction(this.state.selectionList);
        this.closeModal(id || "standardSelectModal");
    }
    //#endregion

    //#region FilterData
    searchInTable = async (value = "") => {
        const { data, headers } = this.props;
        const columnsToFilter = headers.filter(({filter}) => filter) || [];
        let searchResult = data;

        this.setState({ searchBar: value });

        if (value.trim() !== "") {
            let searchTokens = value.toLowerCase().split(" ");
            searchResult = await data.filter(record => {
                const formattedRow = columnsToFilter.map(({field}) => record[field]).join(" ");
                let tokens = formattedRow.toLowerCase().split(" ");
                let match = searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token)));
                return match;
            });
        }

        await this.setState({ data: searchResult });
        this.dataTable.current.first();
    }
    //#endregion

    //#region Selección multiple
    selectAllAction = async (currentElements = [], clean = false) => {
        let selectionList = [];
        let selectedAll = !this.state.selectedAll;
        if (clean) { selectedAll = false; }

        if (selectedAll) {
            for (let i = 0; i < currentElements.length; i++) {
                const currentElement = currentElements[i];
                selectionList.push(currentElement[this.props.idSelection]);
            }
        }

        await this.setState({ selectedAll, selectionList});
    };

    selectOneAction = async (currentElement, currentElements = []) => {
        let selectionList = this.state.selectionList.slice();
        let selectedAll = false;

        if (!selectionList.find(element => element === currentElement)) {
            selectionList.push(currentElement);
            if (selectionList.length === currentElements.length) { selectedAll = true; }
        } else { selectionList = selectionList.filter(element => element !== currentElement); }

        await this.setState({ selectedAll, selectionList});
    };
    //#endregion

    //#region Render
    render() {
        const {
            id,
            title,
            headers,
            selectAction,
            selection,
            paginated = true,
            disabled = false,
        } = this.props;

        const {
            data,
            searchBar,
        } = this.state;

        const tableProps = {
            actPos: this.props.actPos,
            selection,
            idSelection: this.props.idSelection
        };

        const selectionProps = {
            selectedAll: this.state.selectedAll,
            selectionList: this.state.selectionList,
            selectAllAction: this.selectAllAction,
            selectOneAction: this.selectOneAction,
        };

        return (
            <div>
                <div
                    className="modal fade bd-example-modal-lg modal-open scroll"
                    id={id || "standardSelectModal"}
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ backgroundColor: "#343a40", borderRadius: "0" }}>
                                <h4 className="modal-title" id="modal-basic-title "> {title || "Selección"} </h4>
                                <button type="button" className="close" onClick={() => this.closeModal(id || "standardSelectModal")} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <StandardDataTable
                                                ref={this.dataTable}
                                                disabled={disabled}

                                                id={`${id || ""}StandardDataTable`}
                                                data={data}
                                                headers={headers || headersDefault}
                                                action={selectAction}
                                                searchBar={searchBar}
                                                searchInTable={this.searchInTable}
                                                paginated={paginated}
                                                tableProps={tableProps}
                                                selectionProps={selectionProps} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={() => this.closeModal(id || "standardSelectModal")} >Cerrar</button>
                                {selection === "multiple" && !disabled && <button type="button" className="btn botonCorrect text-black" onClick={this.selectMultipleAction} >Aceptar</button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    //#endregion
}
const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StandardSelectModal);